import { render } from "./ChildRecordsContainer.vue?vue&type=template&id=3246602c&scoped=true&ts=true"
import script from "./ChildRecordsContainer.vue?vue&type=script&lang=ts"
export * from "./ChildRecordsContainer.vue?vue&type=script&lang=ts"

import "./ChildRecordsContainer.vue?vue&type=style&index=0&id=3246602c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3246602c"]])

export default __exports__